import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AdmissionGuidelines from "../Components/AdmissionDetails/AdmissionGuidelines";
import FeeStructure from "../Components/AdmissionDetails/FeeStructure";
import { Getdata } from "../helpers/api.service";
import Breadcrums from "../Components/common/Breadcrums";
import ImageCarousal from "../Components/ImageCarousal";
import dayjs from "dayjs";
import Performance from "../Components/Education/Performance";
import Subjects from "../Components/Education/Subjects";
import Facilities from "../Components/Education/Facilities";
import Projects from "../Components/Education/Projects";
import Streams from "../Components/Education/Streams";
import pdfIcon from "../assets/icons/pdf.svg"

const tabs = [
  { id: "admissionGuidelines", label: "Admission Guidelines" },
  { id: "feeStructure", label: "Fee Structure" },

];

const Education = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { description } = location.state || {};
  // const { title } = useParams();
  const title = "Education";
  let [academicsdata, setAcademicsData] = useState([]);
  let [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);

  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "admissionGuidelines"
  );

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    // navigate(`/page/${tabId}`); // example route for each tab
  };

//   const fetchData = () => {
//     setLoading(true);
//     Getdata(
//       process.env.REACT_APP_URL +
//       `/front/education/facility/fetch/${process.env.REACT_APP_SUBDOMAIN}`
//     )
//       .then((res) => {
//         console.log("News API response:", res);
//         // if (res?.data) {
//         //   setData(res.data);
//         // }
//         setImages(res.data.map((item) => item.image[0]));
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching news:", err);
//         setLoading(false);
//       });
//   };

//   const fetchacAdemicsData = () => {
//     setLoading(true);
//     Getdata(
//       process.env.REACT_APP_URL +
//       `/front/education/academic/fetch/${process.env.REACT_APP_SUBDOMAIN}`
//     )
//       .then((res) => {
//         console.log("fetchacAdemicsData:", res);
//         if (res?.data) {
//           setAcademicsData(res.data?.academics?.[0]);
//         }
//         // setImages(res.data.map((item) => item.image[0]));
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching news:", err);
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     fetchData();
//     fetchacAdemicsData();
//   }, []);

  return (
   <div className="mt-20 px-4 sm:px-6 lg:px-20 xl:px-32 2xl:px-48">
      {/* Heading */}
      <div className="font-bold text-primary_main text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
        Admission Details
      </div>

      {/* Tabs */}
      <div className="w-full flex flex-wrap gap-3 mt-4 sm:mt-6 mx-auto max-w-xs sm:max-w-sm md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`px-4 sm:px-5 py-2 rounded-lg text-sm sm:text-base md:text-lg font-medium transition 
              ${activeTab === tab.id
                ? "bg-secondary_main text-white"
                : "bg-[#EEF0F2] text-[#7C7C7C] font-normal hover:bg-gray-200"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-6 sm:mt-8">
        {activeTab === "admissionGuidelines" && <AdmissionGuidelines />}
        {activeTab === "feeStructure" && <FeeStructure />}
      </div>
    </div>

  );
};

export default Education;
